import isNil from "lodash/isNil";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { SelectedFilters } from "#modules/similarPart/view/filters/SelectedFilters";
import { FilterButton } from "#shared/view/components/FilterButton";
import { Group } from "#shared/view/components/Group";
import { Stack } from "#shared/view/components/Stack";
import { Title } from "#shared/view/components/Title";
import { FilterQuery } from "shared";

type Props = {
  filtersParams: FilterQuery | undefined;
  setFiltersParams: (params: FilterQuery) => void;
  onSearch: () => void;
  part?: PartDto | null;
  title?: string;
  toggleDisplayFeatures?: () => void;
  displayFeatures?: boolean;
  toggleDisplayScore?: () => void;
  displayScore?: boolean;
  dimensionWeight?: number;
  setDimensionWeight?: (value: number) => void;
};

export const ResultToolbar = ({
  filtersParams,
  setFiltersParams,
  onSearch,
  part,
  title,
  toggleDisplayFeatures,
  displayFeatures,
  toggleDisplayScore,
  displayScore,
  dimensionWeight,
  setDimensionWeight,
}: Props) => {
  const hasFiltersParams = !!filtersParams?.filterGroup.expressions.filter(
    (expression) => !isNil(expression.value),
  ).length;

  const hasDimensionsFilter = !!part?.length && !!part.width && !!part.height;

  return (
    <Group justify={"space-between"} align="flex-end">
      <Stack gap="xs">
        <Title>{title}</Title>
        {hasFiltersParams && (
          <SelectedFilters
            filtersParams={filtersParams}
            removeFilter={setFiltersParams}
            refetch={onSearch}
            hasDimensionsFilter={hasDimensionsFilter}
          />
        )}
      </Stack>
      <Group>
        <FilterButton
          filtersParams={filtersParams}
          updateFilters={setFiltersParams}
          refetch={onSearch}
          hasDimensionsFilter={hasDimensionsFilter}
          displayFeatures={displayFeatures}
          toggleDisplayFeatures={toggleDisplayFeatures}
          displayScore={displayScore}
          toggleDisplayScore={toggleDisplayScore}
          dimensionWeight={dimensionWeight}
          setDimensionWeight={setDimensionWeight}
        />
      </Group>
    </Group>
  );
};
